const KeenSlider = window.KeenSlider

const { setInitialised, useArrows } = window.BAO.Carousel.plugins

class ProductMedia extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!this.els?.slide?.exists) return

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    const initialSlide = this.els.slide.elements.findIndex(
      (el) => el.dataset.initialSlide === 'true',
    )

    const slider = new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: false,
        mode: 'snap',
        initial: initialSlide,
        slides: {
          perView: 1,
          spacing: 0,
        },
      },
      [
        setInitialised(),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
      ],
    )

    this.els.thumbnail?.elements?.forEach((thumb, index) => {
      thumb.addEventListener('click', () => slider.moveToIdx(index))
    })

    return slider
  }

  moveToIdx (index) {
    if (this.carousel) {
      index = parseInt(index, 10)
      this.carousel.moveToIdx(index)
    }
  }
}

if (!customElements.get('product-media')) {
  customElements.define('product-media', ProductMedia)
}
